var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Coming Soon!")]),_c('v-skeleton-loader',{attrs:{"loading":true,"height":"800","type":"card-avatar, article, actions"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }